import { render, staticRenderFns } from "./smsHelp.vue?vue&type=template&id=01543674&scoped=true"
import script from "./smsHelp.vue?vue&type=script&lang=js"
export * from "./smsHelp.vue?vue&type=script&lang=js"
import style0 from "./smsHelp.vue?vue&type=style&index=0&id=01543674&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01543674",
  null
  
)

export default component.exports